<div class="downarrow-container"><a :href="nextId"><img class="main-cta downarrow" src="@/assets/icons/down-chevron-100x53.png"></a></div>